import { all } from 'redux-saga/effects';

import emailNotificationSaga from './emailNotification';
import paymentMethodSagas from './paymentMethod';
import bankAccountSaga from './bankAccount';
import settingAccountSaga from './account';
import settingBillingSaga from './billing';
import settingCheckoutSaga from './checkout';
import settingPublicProfileSaga from './publicProfile';
import settingReceiptSaga from './receipt';
import settingInventorySaga from './inventory';

export default function* settingSaga() {
  yield all([
    emailNotificationSaga(),
    paymentMethodSagas(),
    bankAccountSaga(),
    settingAccountSaga(),
    settingBillingSaga(),
    settingCheckoutSaga(),
    settingPublicProfileSaga(),
    settingReceiptSaga(),
    settingInventorySaga(),
  ]);
}
